import React from "react";

const Footer = () => {
  return (
    <footer className="flex">
      © Copyright 2024 - Developed by Vijay Tak. All right reserved.
    </footer>
  );
};

export default Footer;
